<!-- Floating Vedha Image -->
<div class="floating-vedha"
     #floatingVedha
     [style.transform]="vedhaTransform"
     [style.opacity]="vedhaOpacity">
  <!-- <img src="assets/images/vedha.webp" alt="Vedha" class="vedha-image"> -->
</div>

<app-navbar></app-navbar>
<section class="remove-padding relative view-height-100vh white-bg" id="home">
    <div class="parallax-overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12 display-table view-height-100vh ">
                <div class="v-align-middle text-center">
                    <div class="white-color text-center">
                        <h1 class="font-100 raleway-font font-80px line-height-80 xs-font-30px xs-line-height-30">Ask
                            <span class="secondary-color">Vedha</span></h1>
                        <h4 class="font-700 font-40px line-height-40 xs-font-20px">Virtual Intelligence Desk AI</h4>
                        <p class="font-18px mt-20 mb-30 xs-font-14px">Ask any question from your textbooks and get instant, easy-to-understand answers!</p>
                        <p class="mt-20 ">
                            <!-- mr-10 -->
                            <a class="btn btn-lg btn-gradient-secondary btn-circle mt-10">Start Learning</a>
                            <a class="btn btn-lg btn-light btn-circle mt-10 mr-10">Watch Demo</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <video autoplay [muted]="isMuted" loop class="html5-video">
        <source src="assets/videos/explore.mp4" type="video/mp4">
        <source src="assets/videos/assets\images\demo-imgs" type="video/webm">
    </video> -->
    <!-- remove the <video>...</video> and add this -->
<picture class="hero-media" aria-hidden="true">
  <source srcset="./assets/images/demo-imgs/AskvedhaBanner.webp" type="image/webp" />
  <img
    src="./assets/images/demo-imgs/AskvedhaBanner.webp"
    alt=""
    loading="eager"
    decoding="async"
    class="hero-media-img"
  />
</picture>

</section>

<section class="white-bg lg-section xs-pb-100 xs-pt-100" id="features">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-right">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/main/Student-with-Askvedha.webp);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6">
            <div class="section-title mb-20">
                <h2 class="raleway-font secondary-color mt-0 font-20px">How AskVedha Works</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">AI-Powered Learning</h1>
            </div>
            <p>AskVedha is an intelligent AI companion designed specifically for school students. Simply ask any question from your textbooks, and our advanced AI will provide clear, age-appropriate explanations that help you understand concepts better.</p>
            <div class="mt-30">
                <div class="mb-20">
                    <i class="fas fa-lightbulb secondary-color font-20px mr-10"></i>
                    <strong>Instant Answers:</strong> Get explanations in seconds
                </div>
                <div class="mb-20">
                    <i class="icon-book-open secondary-color font-20px mr-10"></i>
                    <strong>All Subjects:</strong> Math, Science, History, English & more
                </div>
                <div class="mb-20">
                    <i class="fas fa-graduation-cap secondary-color font-20px mr-10"></i>
                    <strong>Grade-Appropriate:</strong> Answers tailored to your level
                </div>
            </div>
            <!-- <p class="mt-30 mb-0"><a class="btn btn-lg btn-gradient-secondary btn-circle">Try AskVedha</a></p> -->
        </div>
    </div>
</section>

<section class="white-bg lg-section xs-pt-100 xs-pb-100">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-left">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/main/Genie-and-Boy-Learn-Corn-Growth.webp);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6 offset-md-7 offset-md-6">
            <div class="section-title mb-20">
                <h2 class="raleway-font secondary-color mt-0 font-20px">Why Choose AskVedha</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">Smart Learning Made Simple</h1>
            </div>
            <p>AskVedha transforms the way students learn by providing personalized, AI-powered assistance. Our advanced technology understands your questions and provides explanations that match your grade level and learning style.</p>
            <div class="mt-30">
                <div class="mb-15">
                    <i class="icon-check secondary-color font-16px mr-10"></i>
                    <span>Available 24/7 for homework help</span>
                </div>
                <div class="mb-15">
                    <i class="icon-check secondary-color font-16px mr-10"></i>
                    <span>Covers all major school subjects</span>
                </div>
                <div class="mb-15">
                    <i class="icon-check secondary-color font-16px mr-10"></i>
                    <span>Safe and child-friendly environment</span>
                </div>
            </div>
            <!-- <p class="mt-30 mb-0"><a class="btn btn-lg btn-gradient-primary btn-circle">Learn More</a></p> -->
        </div>
    </div>
</section>

<section class="gradient-bg-two pt-80 pb-80">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title mb-50 white-color text-center">
                    <h1 class="raleway-font remove-margin font-50px font-300">Our Process</h1>
                </div>
            </div>
        </div>
        <div class="row our-process-style-02">
            <div *ngFor="let step of steps" class="col-md-3 col-sm-6 col-xs-12 line xs-mb-30 sm-mb-30">
                <div class="icon-wrap white-bg">
                    <div class="icon">
                        <i [ngClass]="step.icon"></i>
                    </div>
                </div>
                <div class="text-center white-color">
                    <h4 class="font-500">{{step.title}}</h4>
                    <p class="mb-0">{{step.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="white-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-23 text-left sm-mt-0 d-flex mb-5 align-items-center">
                <div class="d-block pl-30 sm-pl-0">
                    <div class="section-title mb-20">
                        <h2 class="raleway-font secondary-color mt-0">AskVedha helps students with all subjects</h2>
                        <h1 class="raleway-font mt-30 font-50px font-300">Get Help With <span class="type-it secondary-color">{{ displayedText }}</span></h1>
                    </div>
                    <p>From complex math equations to science experiments, from literature analysis to historical events - AskVedha is your comprehensive learning companion. Our AI understands your questions and provides clear, step-by-step explanations tailored to your grade level.</p>
                    <!-- <p class="mt-30 mb-0"><a class="btn btn-lg btn-gradient-secondary btn-circle">Read more</a></p> -->
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="responsive-screen mt-0">
                    <img src="assets/images/main/Askvedha.webp" class="img-responsive" alt="laptop">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="grey-bg" id="team">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font secondary-color">Learning Made Simple</h2>
                    <h1 class="raleway-font">Your Virtual Teachers</h1>
                </div>
                <p>Students are excited to learn with Ask Vedha. We believe learning should be enjoyable and accessible for every child  and Ask Vedha is making that possible by turning curiosity into confidence.</p>
            </div>
        </div>
        <div class="row mt-50">
            <div class="col-md-4 col-sm-6 col-xs-12 sm-mb-30 xs-mb-30" *ngFor="let slide of slideStoreTwo">
                <div class="team-member">
                    <div class="team-thumb">
                        <div class="thumb-overlay"></div>
                        <img src="assets/images/team/{{slide.image}}" alt="">
                        <!-- <div
                            [ngClass]="slide.index === 0 ? 'member-info text-center gradient-bg' : 'member-info text-center gradient-bg-two'">
                            <h3>{{slide.subtitle}}</h3>
                            <span class="title">{{slide.title}}</span>
                            <ul class="social-link list-inline">
                                <li *ngFor="let social of socialLinks">
                                    <a href="#" [ngClass]="social.iconOuter"><i
                                            [ngClass]="social.iconInner"></i></a>
                                </li>
                            </ul>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="white-bg pb-80" id="services">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font secondary-color">What We Offer</h2>
                    <h1 class="raleway-font">Educational Subjects</h1>
                </div>
                <p>AskVedha covers all major school subjects with comprehensive support. Our AI is trained on curriculum standards and provides grade-appropriate explanations that help students understand concepts better and build confidence in their learning journey.</p>
            </div>
        </div>

        <div class="row mt-50">
            <div *ngFor="let service of services" class="col-md-4 col-sm-4 col-xs-12 mb-30 feature-box text-center hover-effect">
                <div class="gradient-bg-icon-two mb-20">
                    <i [ngClass]="service.icon"></i>
                </div>
                <h5 class="mt-10">{{service.title}}</h5>
                <p class="font-400">{{service.desc}}</p>
            </div>
        </div>

    </div>
</section>

<section class="gray-bg" id="about">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font secondary-color">We Are AskVedha</h2>
                    <h1 class="raleway-font">About Our Mission</h1>
                </div>
                <p>AskVedha is dedicated to revolutionizing education through artificial intelligence. We believe every student deserves personalized learning support that adapts to their unique needs and learning style. Our mission is to make quality education accessible to all students, regardless of their location or background.</p>
            </div>
        </div>
        <div class="row mt-50">
            <div class="col-md-7 col-xs-12">
            <video id="heroVideo" class="img-responsive border-radius-25" src="assets/images/video/Ask_Vedha_loop.mp4" autoplay loop
                muted playsinline controls preload="metadata">
            </video>
            </div>
            <div class="col-md-5 mt-30 col-xs-12">
                <div class="skillbar-wrap skillbar-style-01">
                    <div *ngFor="let skill of skills" class="pl-30 sm-pl-0">
                        <div class="skillbar">
                            <span class="skillbar-title text-uppercase">{{ skill.name }}</span>
                            <p class="skillbar-bar gradient-bg-two" role="progressbar" [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"></p>
                            <span class="skill-bar-percent">{{ skill.level }}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="gradient-bg-two xs-pb-60" style="background: #f6f8ff url('assets/images/team/teachers.png') center/cover no-repeat;">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-left bg-flex-cover" >
      <div class="bg-flex-holder bg-flex-cover"  >
        <!-- <div class="video-box_overlay">
          <div class="center-layout">
            <div class="v-align-middle"> 
                <a (click)="openPopup()">
                    <div class="play-button"><i class="tr-icon ion-android-arrow-dropright"></i></div>
                </a> 
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="container-fluid">
      <div class="col-md-6 col-sm-6 offset-md-6 offset-sm-6">
        <div class="col-inner spacer text-center  " style="margin-top: 100px;">
          <!-- <h2 class="raleway-font mt-0 font-20px xs-font-17px"><b>See AskVedha in Action</b></h2> -->
          <!-- <h1 class="raleway-font mt-0 font-50px font-300 xs-font-27px">Watch Demo Video</h1> -->
          <!-- <p style="color: black;" ><b>Discover how AskVedha transforms learning with AI-powered assistance.<br> See real students getting instant help with their homework and studies.</b> </p> -->
          <!-- <p><a href="#." class="btn btn-md btn-circle btn-light-outline mt-30">Try AskVedha</a></p> -->
        </div>
      </div>
    </div>
</section>

<!-- Video Popup -->
<!-- <div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/sU3FkzUKHXU?si=vhtmR7XG-9HXU6Ij" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='icofont icofont-close'></i>
        </button>
    </div>
</div> -->

  <section class="grey-bg" id="AIAvatars">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font secondary-color">Meet Our AI Avatars</h2>
                    <h1 class="raleway-font">Learn with great minds</h1>
                </div>
                <p>We believe every child deserves a teacher who inspires curiosity and creativity. With our AI avatars, students can explore subjects at their own pace, interact with legendary figures, and gain a deeper understanding of the world around them.</p>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row mt-50">
            <div *ngFor="let portfolio of portfolios" class="col-md-3 col-sm-6 portfolio with-spacing">
                <div class="portfolio-item border-white-15">
                    <a href="javascript:void(0)">
                        <img src="assets/images/team/{{portfolio.img}}" alt="">
                        <!-- <div class="portfolio-info gradient-bg-two">
                            <div class="centrize">
                                <div class="v-center white-color">
                                    <h3>{{portfolio.title}}</h3>
                                    <p>{{portfolio.subTitle}}</p>
                                </div>
                            </div>
                        </div> -->
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="parallax-bg fixed-bg" style="background-image: url('./assets/images/demo-imgs/AskvedhaBanner.webp')">
    <div class="gradient-overlay-bg"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center parallax-content height-400px">
                <div class="center-layout">
                    <div class="v-align-middle">
                        <h1 class="font-400 white-color raleway-font xs-font-40px">We Make Learning Easy and Fun.
                            Every Question Has an Answer.</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="grey-bg" id="pricings">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title mb-50">
                    <h2 class="raleway-font secondary-color">Choose Your Learning Plan</h2>
                    <h1 class="raleway-font">Affordable Education for All</h1>
                </div>
                <p>Start your learning journey with AskVedha today! Choose from our flexible plans designed for students, families, and schools. All plans include unlimited questions, comprehensive subject coverage, and our commitment to safe, effective learning.</p>
            </div>
        </div>
        <div class="row mt-50">
            <div *ngFor="let price of pricing; let i = index" class="col-md-4 pricing-table col-sm-4 xs-mb-30 hover-effect">
                <div
                    class="pricing-box border-radius-25 {{ i === 1 ? 'pricing-box-gradient' : 'pricing-box-gradient-two' }} text-center white-color">
                    <h3 class="mb-0 raleway-font">{{price.title}}</h3>
                    <h4>{{price.subTitle}}</h4>
                    <h2 class="font-60px sm-font-40px"><sup>{{price.currency}}</sup><span>{{price.amount}}</span></h2>
                    <ul class="list-style-02">
                        <li *ngFor="let feature of price.features">{{ feature }}</li>
                    </ul>
                    <div class="pricing-box-bottom"> <a [ngClass]="price.btnClass">{{price.btnText}}</a> </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="white-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title mb-50">
                    <h2 class="raleway-font secondary-color">What Students & Parents Say</h2>
                    <h1 class="raleway-font">Success Stories</h1>
                </div>
                <p>Hear from students, parents, and teachers who have experienced the transformative power of AskVedha. Our AI learning companion has helped thousands of students improve their understanding and achieve better grades.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <owl-carousel-o [options]="customOptionsThree" class="testimonial gradient-bullet-two owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreThree">
                        <div class="testimonial-item">
                            <div class="testimonial-content border-radius-25">
                                <img class="img-responsive rounded-circle text-center" src="{{slide.image}}" alt="" />
                                <h4 class="font-600 mb-0 raleway-font">{{slide.title}}</h4>
                                <span class="secondary-color font-14px">{{slide.subTitle}}</span>
                                <div class="clearfix mb-20"></div>
                                <i class="icofont icofont-quote-left font-50px secondary-color mt-20"></i>
                                <p class="mt-20 line-height-26 font-14px">{{slide.description}}</p>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section> -->

<!-- <div class="grey-bg pt-120 pb-120">
    <div class="container">
        <div class="row">
            <div class="client-slider">
                <owl-carousel-o [options]="customOptionsFour" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreFour">
                        <div class="client-logo">
                            <img class="img-responsive" src="{{slide.image}}" alt="01" />
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>

    </div>
</div> -->

<!-- <section class="gradient-bg xs-pb-60" id="blog">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-right">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/blog-img.jpg);"></div>
    </div>
    <div class="container-fluid">
        <div class="col-md-6 col-sm-6">
            <div class="col-inner spacer white-color text-center">
                <h2 class="raleway-font mt-0 font-20px xs-font-17px">Educational Resources</h2>
                <h1 class="raleway-font mt-0 font-50px font-300 xs-font-27px">Learning Tips & Updates</h1>
                <p>Stay updated with the latest educational trends, study tips, and AskVedha features.<br> Discover new ways to enhance your learning experience with our AI companion. </p>
                <p><a routerLink="/blog-details" class="btn btn-md btn-square btn-light-outline mt-30">See Blog Details</a></p>
            </div>
        </div>
    </div>
</section> -->

<section class="white-bg transition-none" id="contact">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font secondary-color">Need Help or Have Questions?</h2>
                    <h1 class="raleway-font">Get in Touch with AskVedha</h1>
                </div>
                <p>Whether you're a student, parent, or educator, we're here to help! Contact us for support, partnership opportunities, or to learn more about how AskVedha can enhance your learning experience.</p>
            </div>
        </div>
    </div>

    <iframe class="mt-10" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.4425341966353!2d79.13463399999999!3d12.8792412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad39d34dd0c06f%3A0x5f7e45bd50d56f02!2sKuvira%20Cybernetics!5e0!3m2!1sen!2sin!4v1754484050003!5m2!1sen!2sin" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

    <div class="container">
        <div class="row mt-70">
            <div class="col-md-6 col-sm-6 col-xs-12 xs-mb-50">
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font secondary-color">Contact Email</h2>
                            <p class="mt-30">AskVedha<br>
                                ask&#64;askvedha.com
                            </p>
                            <p class="mt-30">Mobile Number<br>
                                9090608181
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font secondary-color">Support Hours</h2>
                            <p class="mb-0 mt-30">Monday - Friday: 9:00 AM - 6:00 PM IST</p>
                            <p class="mb-0">Weekend: 10:00 AM - 4:00 PM IST</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font secondary-color">Contact Email</h2>
                            <p class="mb-0 mt-30">General : hello&#64;askvedha.com</p>
                            <p class="mb-0">Schools : schools&#64;askvedha.com</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font secondary-color">Quick Support</h2>
                            <p class="mb-0 mt-30">Support : support&#64;askvedha.com</p>
                            <p class="mb-0">Partnerships : partners&#64;askvedha.com</p>
                        </div>
                    </div>
                </div> -->
                <div class="row mt-20">
                    <div class="col-md-12 social-icons-style-06">
                        <ul class="md-icon left-icon">
                          <li *ngFor="let social of socialMedia">
                            <a [ngClass]="social.iconClass" href="{{social.link}}" target="_blank"><i [ngClass]="social.icon"></i></a>
                          </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <form class="contact-form-style-01" #contactForm="ngForm">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label class="visually-hidden" for="user_name">Name</label>
                                <input type="text" minlength="2" maxlength="15"
                                    [class.is-invalid]="userName.invalid && userName.touched" name="user_name"
                                    class="md-input" id="name" placeholder="Name *" [(ngModel)]="formData.user_name"
                                    #userName="ngModel" required>
                                <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mb-10">
                                    Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="mb-3">
                                <label class="visually-hidden" for="user_email">Email</label>
                                <input type="email" minlength="2" maxlength="35"
                                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email"
                                    class="md-input" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                    #userEmail="ngModel" required email>
                                <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mb-10">
                                    A valid email is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="mb-3">
                                <label class="visually-hidden" for="message">Project Details</label>
                                <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                                    class="md-textarea" id="message" rows="7" placeholder="Project Details"
                                    [(ngModel)]="formData.message" #userMessage="ngModel" required></textarea>
                                <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                    Project details are required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="text-left mt-20">
                                <button type="submit" name="submit"
                                    class="btn btn-outline btn-md btn-circle btn-animate remove-margin"
                                    [disabled]="contactForm.invalid" value="Send" (click)="sendMessage(formData)">
                                    <!-- <span>Send Message <i class="ion-android-arrow-forward"></i></span> -->
                                      <span *ngIf="!sending">Send Message <i class="ion-android-arrow-forward"></i></span>
                                        <span *ngIf="sending">
                                            <i class="fa fa-spinner fa-spin"></i> Sending...
                                        </span>
                                </button>
                            </div>
                            <!-- ✅ Success Message -->
                            <p *ngIf="successMsg" class="text-success mt-2">{{ successMsg }}</p>

                            <!-- ❌ Error Message -->
                            <p *ngIf="errorMsg" class="text-danger mt-2">{{ errorMsg }}</p>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</section>